import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useRouter } from 'next/router';

import { useSingleStringUrlParameter } from '@hooks/common/use-single-string-url-parameter';

function AdminRouteButton() {
  const { basePath } = useRouter();
  const noteAlias = useSingleStringUrlParameter('noteId', '');
  const adminPath = useMemo(
    () =>
      `${basePath.replace(
        'cms/content',
        'manage-article/edit'
      )}/${noteAlias}`,
    [basePath, noteAlias]
  );

  return (
    <Button variant='info' target='_blank' size='lg' href={adminPath}>
      Admin Page
    </Button>
  );
}

export default AdminRouteButton;
